export default __webpack_public_path__ + "static/AnalyzeToImproveYourLeadGeneration-1a0ccd408fe891e4ce6772b732cf19a5.svg";